import { render } from "./PDetails.vue?vue&type=template&id=584c17d8&scoped=true"
import script from "./PDetails.vue?vue&type=script&lang=js"
export * from "./PDetails.vue?vue&type=script&lang=js"

import "./PDetails.vue?vue&type=style&index=0&id=584c17d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584c17d8"]])

export default __exports__